export const API_URL = process.env.REACT_APP_API_URL;
//export const API_URL = "https://api-vinca.quantox.dev/api";
